<ambita-pantebok-order class="ambita-pantebok-order">
  <div class="ambita-pantebok-order__header">
    <span>{ i18n.pantebokOrder.orderCertifiedCopy }</span>
  </div>
  <div class="ambita-pantebok-order__price-wrapper">
    <div class="ambita-pantebok-order__inline-element ambita-pantebok-order__price" show="{ purchaseAllowed }">
      <span data-is="ambita-currency" infoland-currency-fraction="0"
            infoland-currency-amount="{ pantebokProduct.price.salesPriceVat }">
      </span>
      <div class="ambita-pantebok-order__product-fee" show="{ pantebokProduct.price.productFee > 0 }">
        ( +
        <span data-is="ambita-currency" infoland-currency-fraction="0"
              infoland-currency-amount="{ pantebokProduct.price.productFee }">
        </span>
        { i18n.pantebokOrder.productFee } )
      </div>
    </div>
    <div show="{ pantebokPurchased == false && pantebokIsPurchasing != true }"
         class="ambita-pantebok-order__button">
      <button class="ambita-product-order ambita-button ambita-button--available-light ambita-clickable"
              disabled="{ opts.infolandProduct.orderingDisabled || !opts.infolandProduct.purchaseAllowed }"
              onclick="{ purchasePantebok }"
              show="{ purchaseAllowed && productAvailable }">
      <span data-is="ambita-currency" infoland-currency-symbol="{ i18n.pantebokOrder.currencyShortNOK }"
            infoland-currency-amount="{ pantebokProduct.price.salesPriceVat + pantebokProduct.price.productFee }">
      </span>
      </button>
      <span show="{ !purchaseAllowed || !productAvailable }"
            class="ambita-button-placeholder ambita-button-placeholder--disabled">
        { i18n.pantebokOrder.productNotAvailable }
      </span>
      <span show="{ pantebokPurchaseFailed }" class="ambita-pantebok-order__error">
        { i18n.pantebokOrder.purchaseFailed }
      </span>
    </div>
    <div show="{ pantebokIsPurchasing == true }" class="ambita-pantebok-order__button">
      <span class="ambita-button-placeholder ambita-button-placeholder--disabled">
        { i18n.pantebokOrder.purchaseInProgress }
      </span>
    </div>

    <div show="{ pantebokPurchased == true }"
         class="ambita-pantebok-order__purchase-processed ambita-pantebok-order__button">
      <span class="ambita-button-placeholder ambita-button-placeholder--disabled">
        { i18n.pantebokOrder.ordered }
      </span>
    </div>
  </div>

  <script>
    import './currency.tag';
    import './instantPurchase.tag';
    import './pantebokOrder.scss';
    import './pantebokOrderTranslations';
    import { init } from './pantebokOrderController';

    init(this);
  </script>
</ambita-pantebok-order>
